/* eslint-disable camelcase */
import * as types from '../mutation-types';
import api from '../../helpers/api';

async function getTraktorpool() {
  const { id, api_key } = this.getters.getConfig.traktorpool;
  const { ads } = await api.get(`traktorpool/offerer/${id}/detail_ads`, {
    params: {
      api_key,
    },
  });
  return ads;
}

async function getTechnickboerse() {
  const { api_key } = this.getters.getConfig.technikboerse;
  const { data: { items: machines } } = await api.get('technikboerse/ver1/ads', {
    params: {
      limit: 30,
      fields: 'status',
    },
    headers: {
      'x-token': `Bearer ${api_key}`,
    },
  });

  return machines.map((machine) => ({
    ...machine,
    price: {
      value: machine.prices_raw.gross_price,
    },
    vat: {
      value: machine.prices_raw.tax * 100,
    },
    manufacturer: {
      value: machine.manufacturer,
    },
    images: machine.images.map((image) => ({ href: image })),
  }));
}

export default {
  state: {
    all: [],
  },
  getters: {
    getMachines: (state) => state.all,
  },
  actions: {
    async getAllMachines({ commit }) {
      let machines = [];
      if (this.getters.getConfig.technikboerse) {
        machines = await getTechnickboerse.bind(this)();
      } else if (this.getters.getConfig.traktorpool) {
        machines = await getTraktorpool.bind(this)();
      }
      return commit(types.RECEIVED_MACHINES, { machines });
    },
  },
  mutations: {
    [types.RECEIVED_MACHINES](state, { machines }) {
      state.all = machines;
    },
  },
};
